import { MicrosoftXboxControllerBatteryLowIcon } from './MicrosoftXboxControllerBatteryLowIcon';

/**
 * author: Austin Andrews
 * id B65873D1-4808-4C3C-8AD6-A242D61B1985
 * name microsoft-xbox-controller-battery-low
 * version: 1.9.32
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/microsoft-xbox-controller-battery-low.svg
 * tags
 * - Battery 
 * - Gaming / RPG 
 */
export const MicrosoftXboxGamepadBatteryLowIcon = MicrosoftXboxControllerBatteryLowIcon;
export default MicrosoftXboxGamepadBatteryLowIcon